import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { HealthServicesLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Health_Antirabies_VACCINATION_Center = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  min-height-400">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {HealthServicesLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {t("Antirabies Vaccination Centre")}
                    </h3>
                  </div>
                  <div className="mayor-table health-dept-table">
                    <table
                      width="95%"
                      border={0}
                      align="center"
                      cellPadding={2}
                      cellSpacing={2}
                      className="table table-bordered officials"
                    >
                      <tbody>
                        <tr
                          bgcolor="#302ba0"
                          tabIndex={0}
                          align="center"
                          valign="middle"
                        >
                          <td width="7%" className="text-white tble-brder-left">
                            {t("Borough")}
                          </td>
                          <td width="38%" className="text-white">
                            {t("Location")}
                          </td>
                          <td
                            width="37%"
                            className="text-white tble-brder-right"
                          >
                            {t("Landmark")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            I
                          </td>
                          <td width="38%">
                            {t("Chitpur dispensary")} <br />3
                            {t("Gopal mukherjee st kolkata")} - 2<br />
                          </td>
                          <td width="37%">{t("Paikpara more")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            II
                          </td>
                          <td width="38%">
                            {t("Hatibagan dispensary")} <br />
                            {t("160 Aurobinda sarani kolkata")} - 6<br />
                          </td>
                          <td width="37%">
                            {t(
                              "Crossing of apc road & grey street., near khanna cinema"
                            )}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            III
                          </td>
                          <td width="38%">
                            {t(
                              "Narkeldanga dispensary 109 Narkeldanga main rd."
                            )}
                            <br />
                            {t("kolkata")} - 54
                            <br />
                          </td>
                          <td width="37%">{t("Phoolbagan more")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            IV
                          </td>
                          <td width="38%">
                            {t(
                              "Ward health unit, ward 25 9a, baranashi ghosh lane, kolkata – 6"
                            )}
                          </td>
                          <td width="37%">{t("Simla byam samity")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            V
                          </td>
                          <td width="38%">
                            {t("Ward health unit, ward 49")}
                            <br />
                            {t("34 Surya sen street kolkata")} - 9<br />
                          </td>
                          <td width="37%">Shraddhananda park</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            VI
                          </td>
                          <td width="38%">
                            {t("Taltala dispensary")}
                            <br />
                            {t("3 Girish chandra bose rd. kolkata")} - 14
                            <br />
                          </td>
                          <td width="37%">
                            {t("Kmc garage, behind old gem cinema")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            VII
                          </td>
                          <td width="38%">
                            {t("Dhapa dispensary, ward 58")}
                            <br />
                            {t("2 Dhapa bazar 2 dhapa kol")}
                          </td>
                          <td width="37%">Dhapa bazar</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            VIII
                          </td>
                          <td width="38%">
                            {t("Borough viii office")}
                            <br />
                            {t("Vivekananda park jatin bagchi rd. kolkata")} -
                            29
                            <br />
                          </td>
                          <td width="37%">{t("Vivekananda park")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            IX
                          </td>
                          <td width="38%">
                            {t("Chetla dispensary")}
                            <br />
                            {t("29/5 chetla central rd. kolkata")} - 27
                            <br />
                          </td>
                          <td width="37%">{t("Chetla boy’s school")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            X
                          </td>
                          <td width="38%">
                            {t("Ward health unit, ward 81")}
                            <br />
                            {t("16, mondal temple rd. kolkata")} - 53 <br />
                          </td>
                          <td width="37%">{t("New alipur sbi")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            X
                          </td>
                          <td width="38%">
                            {t(
                              "Ward health unit, ward 96 (lyalka chest clinic)"
                            )}
                            <br />
                            {t("lyalka rd. kolakta - 92")} <br />
                          </td>
                          <td width="37%">{t("Lyalka")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            XI
                          </td>
                          <td width="38%">
                            {t("Kmc, dispensary, ward 114")}
                            <br />
                            {t("purba putiyari kolkata - 93")}
                            <br />
                          </td>
                          <td width="37%">{t("Sourjashree club")}</td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            XII
                          </td>
                          <td width="38%">
                            {t("Esopd")}
                            <br />
                            {t("47 garfa main rd. kolkata - 93")} <br />
                          </td>
                          <td width="37%">
                            {t("Palbazar, state bank of india")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            XIII
                          </td>
                          <td width="38%">
                            {t("Ward health unit, ward 123")}
                            <br />
                            {t("2 raja rammohan roy rd. kolkata - 8")}
                            <br />
                          </td>
                          <td width="18%">
                            {t("Barisha high school, behala chowrasta")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            XIV
                          </td>
                          <td width="38%">
                            {t("Ward health unit, ward 132")}
                            <br /> {t("upen banerji rd. parnasri kol - 60")}
                            <br />
                          </td>
                          <td width="18%">
                            {t("Nababani park, parnasree bus stand")}
                          </td>
                        </tr>
                        <tr tabIndex={0} align="left" valign="top">
                          <td width="7%" align="center">
                            XV
                          </td>
                          <td width="38%">
                            {t("Garden reach maternity home dispensary")}
                            <br />
                            {t("b-3 prince dilwar jaan kol-24")}
                            <br />
                          </td>
                          <td width="37%">{t("Kamal talkies cinema")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Health_Antirabies_VACCINATION_Center;
